import { render, staticRenderFns } from "./identify-people.vue?vue&type=template&id=09b099ee&scoped=true"
import script from "./identify-people.vue?vue&type=script&lang=js"
export * from "./identify-people.vue?vue&type=script&lang=js"
import style0 from "./identify-people.vue?vue&type=style&index=0&id=09b099ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b099ee",
  null
  
)

export default component.exports